<template>
    <section id="tour_booking_submission" class="booking_submission section_padding">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="mb20">
                        <div id="pass-adult-info" class="mb20">
                            <div id="bk-pass-all">
                                <div class="row list">
                                    <div v-for="(item, index) in passengers" :data-id="item.id" :data-type="item.type"
                                        :key="item.id" class="col-md-4 col-12 col-sm-12 mb15 pass-card"
                                        :disabled="isCardDisabled(item) ? 'disabled' : 'false'">
                                        <div class="pass-spec-container">
                                            <div class="not-pass"></div>
                                            <div class="row no-margin align">
                                                <div
                                                    class="col-md-12 col-sm-12 col-xs-12 col-12 p-0 no-padding col-middle">
                                                    <label>
                                                        <div class="pass-details">
                                                            <div class="right">
                                                                <div
                                                                    style="display: flex;justify-content: space-between;gap:8px;">
                                                                    <span class="clearfix no-margin w-100">
                                                                        {{ item.first_name }}
                                                                        {{ item.last_name }}
                                                                    </span>
                                                                    <div class="icheckbox_square-green"
                                                                        style="position: relative;">
                                                                        <label class="checkbox-container">
                                                                            <input type="checkbox" class="select-pass"
                                                                                :checked="isSelected(item)"
                                                                                @change="toggleSelection($event, item)">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <span class="clearfix no-margin">
                                                                    {{ $t('Passport') }}
                                                                    ({{
                                                                        getCountriesByCode(item.passport_issuing_country)[$i18n.locale
                                                                        + '_label'] }})
                                                                </span>
                                                                <div
                                                                    style="display: flex;flex-wrap: wrap;-webkit-box-pack: justify;justify-content: space-between;">
                                                                    <div>
                                                                        {{ item.passport_number }}
                                                                    </div>
                                                                    <div>
                                                                        {{ $t('Expires') }}
                                                                        <time>
                                                                            {{
                                                                                getFormattedDate(item.passport_expiry_date)
                                                                            }}
                                                                        </time>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center mt-4">
                    <button type="button" class="btn btn_theme btn_md w-25 " @click="next_summary">
                        {{ $t('Next') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import $ from 'jquery';
import { toast } from 'vue3-toastify';
import jsonData from '@/assets/file/airlines-v2.json';
import countriesData from '@/assets/file/countries.json';
import { diffYears, formatDate } from '@/utils/dateUtils';
import LvOverlayPanel from 'lightvue/overlay-panel';
import { ModelListSelect } from 'vue-search-select';
import LvButton from 'lightvue/button';

export default {
    name: 'FlightPassengersArea',
    data: () => ({
        options: [],
        passengers: [],
        adults: [],
        infants: [],
        children: [],
        years: [],
        searchData: [],
    }),
    components: {
        LvOverlayPanel,
        LvButton,
        ModelListSelect,
    },
    methods: {
        codeNameAndDesc(item) {
            return `${item[this.$i18n.locale + '_name']} (${item.code})`
        },
        toggle(event, index) {
            this.$refs.passenger[index].toggle(event);
        },
        cancelMemb(index) {
            this.$refs.passenger[index].hide();
            this.passengers[index]['LoyaltyProgram'] = [{ "programOwner": null, "id": null }];
        },
        submitMemb(index) {
            var forms = document.querySelectorAll('.needs-validation')
            forms[0].classList.add('was-validated');
            if (!forms[0].checkValidity() || !this.passengers[index].LoyaltyProgram[0].programOwner) {
                toast.error(this.$t('All fields are required'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
                return;
            }
            this.$refs.passenger[index].hide();
        },
        getCountriesByCode(code) {
            var info = countriesData.filter(item => {
                return item.value.includes(code);
            });
            return info[0];
        },
        getFormattedDate(dateString) {
            const { day, month, year } = formatDate(dateString);
            return `${day} ${this.$t(month)} ${year}`;
        },
        diff_years(dt2, dt1) {
            return diffYears(dt2, dt1);
        },
        next_summary() {
            const pass = [this.adults, this.infants, this.children];
            var passengers = pass.flat();
            var adult = this.searchData.adults,
                child = this.searchData.children,
                infant = this.searchData.infants;
            if (adult + child + infant != passengers.length) {
                toast.error(this.$t('Please select passenger(s)'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
                return;
            }
            this.passengers = this.passengers.filter((item) => {
                return passengers.includes(item.id);
            });
            passengers = [];
            this.passengers.forEach(element => {
                passengers.push(element.encrypted_id);
            });
            localStorage.setItem('passengers', JSON.stringify(passengers));
            localStorage.setItem('passengersDetails', JSON.stringify(this.passengers));
            this.$router.push(`/flight-confirmation`);
        },
        toggleSelection(event, item) {
            const isChecked = event.target.checked;
            const type = item.type;
            if (isChecked) {
                if (type === 'Adult') this.adults.push(item.id);
                else if (type === 'Child') this.children.push(item.id);
                else if (type === 'Infant') this.infants.push(item.id);
            } else {
                if (type === 'Adult') this.removeItem(this.adults, item.id);
                else if (type === 'Child') this.removeItem(this.children, item.id);
                else if (type === 'Infant') this.removeItem(this.infants, item.id);
            }
        },
        removeItem(list, id) {
            const index = list.indexOf(id);
            if (index > -1) list.splice(index, 1);
        },
        isSelected(item) {
            if (item.type === 'Adult') return this.adults.includes(item.id);
            if (item.type === 'Child') return this.children.includes(item.id);
            if (item.type === 'Infant') return this.infants.includes(item.id);
            return false;
        },
        isCardDisabled(item) {
            const type = item.type;
            if (type === 'Adult') return !this.adults.includes(item.id) && this.adults.length >= this.searchData.adults;
            if (type === 'Child') return !this.children.includes(item.id) && this.children.length >= this.searchData.children;
            if (type === 'Infant') return !this.infants.includes(item.id) && this.infants.length >= this.searchData.infants;
            return false;
        },
        randomDate(start, end) {
            return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
        },
        formatDate(date) {
            return date.toISOString().split('T')[0];
        },
        createPassenger(type) {
            const genders = ['Male', 'Female'];
            const nationalities = ['SA', 'AE', 'US', 'IN', 'FR'];

            const getRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

            const gender = getRandom(genders);

            let birthdate;

            const today = new Date();

            if (type === 'Infant') {
                birthdate = this.randomDate(new Date(today.getFullYear() - 2, 0, 1), today);
            } else if (type === 'Child') {
                birthdate = this.randomDate(new Date(today.getFullYear() - 11, 0, 1), new Date(today.getFullYear() - 3, 11, 31));
            } else {
                birthdate = this.randomDate(new Date(today.getFullYear() - 60, 0, 1), new Date(today.getFullYear() - 12, 11, 31));
            }

            return {
                id: Math.floor(Math.random() * 100000),
                encrypted_id: Math.random().toString(36).substring(2, 12),
                type: type,
                title: gender === 'Female' ? 'ms' : 'mr',
                first_name: gender === 'Female' ? 'Fatima' : 'Ali',
                last_name: 'Ahmad',
                registration_number: 'REG' + Math.floor(Math.random() * 9999),
                category: 'Economy',
                birthday: this.formatDate(birthdate),
                email: 'test@example.com',
                mobile: '+9665' + Math.floor(10000000 + Math.random() * 89999999),
                nationality: getRandom(nationalities),
                passport_number: 'P' + Math.floor(1000000 + Math.random() * 8999999),
                passport_issue_date: this.formatDate(this.randomDate(new Date(2015, 0, 1), new Date())),
                passport_issuing_country: getRandom(nationalities),
                passport_expiry_date: this.formatDate(this.randomDate(new Date(), new Date(2035, 0, 1))),
                LoyaltyProgram: [{ programOwner: null, id: null }]
            };
        },
        generateRandomPassengers(adultsCount, childrenCount, infantsCount) {
            const passengers = [];
            for (let i = 0; i < adultsCount; i++) {
                passengers.push(this.createPassenger('Adult'));
            }
            for (let i = 0; i < childrenCount; i++) {
                passengers.push(this.createPassenger('Child'));
            }
            for (let i = 0; i < infantsCount; i++) {
                passengers.push(this.createPassenger('Infant'));
            }
            return passengers;
        }
    },
    mounted() {
        $('.pre-loader').show();
        this.options = jsonData;
        this.adults = [];
        this.children = [];
        this.infants = [];
        this.searchData = JSON.parse(localStorage.getItem("searchData"));
        this.passengers = this.generateRandomPassengers(this.searchData.adults, this.searchData.children, this.searchData.infants);
        setTimeout(() => {
            $('.pre-loader').hide();
        }, 1000);
    },
}
</script>
<style lang="scss">
@import url('@/assets/style/flight-passengers.scss');
</style>